<div class="loyalty-rewards-progressbar section">
    <div class="loyalty-rewards-progress">
        <ng-container *ngIf="showProgressBar">
            <div *ngIf="showScoreCard" class="reward-simplified-container px-2">
                <div class="simplified-container">
                    <div class="points-header">
                        <div class="rewards-icon" aria-hidden="true" role="img">
                            <svg width="40" height="38" viewBox="0 0 40 38" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g id="Points">
                                    <path id="Vector"
                                          d="M21.5158 37.484C31.7235 37.484 40 29.2093 40 18.9998C40 8.79038 31.7252 0.515625 21.5158 0.515625H18.4824V37.484H21.5158Z"
                                          fill="#AD7927"/>
                                    <path id="Vector_2"
                                          d="M18.4842 37.484C28.6919 37.484 36.9684 29.2093 36.9684 18.9998C36.9684 8.79038 28.6919 0.515625 18.4842 0.515625C8.27653 0.515625 0 8.79038 0 18.9998C0 29.2093 8.27476 37.484 18.4842 37.484Z"
                                          fill="#FFC22B"/>
                                    <path id="Vector_3"
                                          d="M18.4842 33.5916C26.5442 33.5916 33.0759 27.058 33.0759 18.9998C33.0759 10.9416 26.5424 4.40625 18.4842 4.40625C10.4259 4.40625 3.89062 10.9398 3.89062 18.9998C3.89062 27.0598 10.4242 33.5916 18.4824 33.5916H18.4842Z"
                                          fill="#E9A238"/>
                                    <path id="Vector_4"
                                          d="M18.4844 36.9824C18.4844 36.9824 24.115 37.1846 28.9533 33.5918"
                                          stroke="#FCE0A2" stroke-miterlimit="10"/>
                                    <path id="Vector_5" opacity="0.2"
                                          d="M18.4844 37.484C28.692 37.484 36.9686 29.2093 36.9686 18.9998C36.9686 8.79038 28.692 0.515625 18.4844 0.515625V37.484Z"
                                          fill="#8C1C25"/>
                                    <path id="Vector_6"
                                          d="M18.484 4.07617C12.2149 4.07617 6.86876 8.02896 4.80273 13.5792"
                                          stroke="#FCE0A2" stroke-miterlimit="10"/>
                                    <path id="Vector_7"
                                          d="M26.4925 18.8527C26.4872 18.8421 26.4801 18.8314 26.4712 18.8226C26.4606 18.8119 26.4464 18.8048 26.4322 18.8013H26.3736C25.2802 18.8013 24.1993 18.5687 23.2 18.1232C22.7456 17.9244 22.3126 17.6795 21.9079 17.3937C20.8962 16.682 20.069 15.7377 19.5011 14.639C18.9313 13.5403 18.6367 12.321 18.6402 11.0838C18.6438 11.0643 18.6438 11.0448 18.6402 11.0253C18.626 10.9986 18.6065 10.9756 18.5816 10.9596C18.5692 10.956 18.555 10.9596 18.5408 10.9596C18.5284 10.956 18.5142 10.9596 18.5 10.9596C18.4893 10.9596 18.4787 10.956 18.468 10.9596C18.4556 10.956 18.4414 10.9596 18.4272 10.9596C18.413 10.9596 18.4006 10.956 18.3864 10.9596C18.3615 10.9756 18.342 10.9986 18.3278 11.0253C18.3243 11.0448 18.3243 11.0643 18.3278 11.0838C18.3314 12.321 18.035 13.5403 17.467 14.639C16.8972 15.7377 16.0719 16.6838 15.0602 17.3937C14.6555 17.6795 14.2224 17.9244 13.768 18.1232C12.7687 18.5687 11.6878 18.8013 10.5944 18.8013H10.5358C10.5216 18.8048 10.5074 18.8137 10.4968 18.8226C10.4879 18.8314 10.4808 18.8421 10.4755 18.8527H10.4702C10.4702 18.8527 10.4702 18.8563 10.4702 18.8598C10.4631 18.8829 10.4631 18.9095 10.4702 18.9326C10.4648 18.9575 10.4648 18.9823 10.4702 19.0054C10.4702 19.0072 10.4702 19.0089 10.4702 19.0125H10.4755C10.4808 19.0231 10.4879 19.0338 10.4968 19.0427C10.5074 19.0533 10.5216 19.0604 10.5358 19.064H10.5944C11.6878 19.064 12.7687 19.2965 13.768 19.742C14.2224 19.9408 14.6555 20.1857 15.0602 20.4715C16.0719 21.1832 16.899 22.1275 17.467 23.2262C18.0367 24.3249 18.3314 25.5443 18.3278 26.7814C18.3243 26.8009 18.3243 26.8204 18.3278 26.84C18.342 26.8666 18.3615 26.8897 18.3864 26.9056C18.3988 26.9092 18.413 26.9056 18.4272 26.9056C18.4414 26.9056 18.4538 26.9092 18.468 26.9056C18.4787 26.9092 18.4893 26.9056 18.5 26.9056C18.5142 26.9056 18.5266 26.9092 18.5408 26.9056C18.555 26.9056 18.5674 26.9092 18.5816 26.9056C18.6065 26.8897 18.626 26.8666 18.6402 26.84C18.6438 26.8204 18.6438 26.8009 18.6402 26.7814C18.6367 25.5443 18.9331 24.3249 19.5011 23.2262C20.0708 22.1275 20.8962 21.1815 21.9079 20.4715C22.3126 20.1857 22.7456 19.9408 23.2 19.742C24.1993 19.2965 25.2802 19.064 26.3736 19.064H26.4322C26.4464 19.0604 26.4606 19.0515 26.4712 19.0427C26.4801 19.0338 26.4872 19.0231 26.4925 19.0125H26.4979C26.4979 19.0125 26.4979 19.0089 26.4979 19.0054C26.5032 18.9805 26.5032 18.9557 26.4979 18.9326C26.505 18.9095 26.505 18.8829 26.4979 18.8598C26.4979 18.8581 26.4979 18.8563 26.4979 18.8527H26.4925Z"
                                          fill="#FECC4D"/>
                                </g>
                            </svg>

                        </div>
                        <div class="shop-earn">
                            {{ balanceDisplay }}
                        </div>
                    </div>
                    <div class="disclaimer-text px-2 py-2">
                        <span [innerHTML]="rewardsPointsDateDetailsDisplay"> </span>
                    </div>
                    <ng-container
                            *ngIf="rewardsResponseObj.rewards.isUserHasRewards && !suspendedFreshPassUser && !nonFreshpassBanners">
                        <ng-container *ngIf="isFreshpassRebrand">
                            <div *ngIf="!freshPassUser" class="freshpass-disclaimer-text px-2 py-2">
                                <p aria-hidden="true" aria-labelledby="sr-text-1">Points don’t expire with&nbsp;<span
                                        class="fp-trademark">{{foruBanner}}<sup>TM</sup>.</span></p>
                                <span  *ngIf="!freshPassUser" class="sr-only" aria-live="polite" id="sr-text-1" role="text" aria-hidden="false">Points don't expire with {{foruBanner}} trademark</span>
                                <div class="ml-2" role="button" tabindex="0" (click)="openFreshpass()"
                                     (keypress)="openFreshpass()"
                                     aria-label="join today , Points dont expire with {{banner}}">
                                    <span class="freshpass-link">Join today</span>
                                </div>
                            </div>
                            <div *ngIf="freshPassUser" class="freshpass-disclaimer-text px-2 py-2">
                                <span aria-hidden="true" aria-labelledby="sr-text-2"> Thanks for being a&nbsp; {{foruBanner}}<sup class="fp-trademark">TM</sup> member! Your Points don’t expire.</span>
                                <span *ngIf="freshPassUser" id="sr-text-2" class="sr-only" aria-live="polite" role="text" aria-hidden="false">
                                Thanks for being a&nbsp; {{foruBanner}} trademark member! Your Points don’t expire.
                            </span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="!isFreshpassRebrand">
                            <div *ngIf="!freshPassUser" class="freshpass-disclaimer-text px-2 py-2">
                                <p aria-hidden="true" aria-labelledby="sr-text-3">Points don’t expire with&nbsp;<span
                                        class="fp-trademark">{{freshpassText}}<sup>®</sup>.</span></p>
                                <span *ngIf="!freshPassUser" class="sr-only" aria-live="polite" id="sr-text-3" role="text" aria-hidden="false">Points don't expire with {{freshpassText}}</span>
                                <div class="ml-2" role="button" tabindex="0" (click)="openFreshpass()"
                                     (keypress)="openFreshpass()"
                                     aria-label="join today , Points dont expire with {{freshpassText}}">
                                    <span class="freshpass-link">Join today</span>
                                </div>
                            </div>
                            <div *ngIf="freshPassUser" class="freshpass-disclaimer-text px-2 py-2">
                                <span aria-hidden="true" aria-labelledby="sr-text-4"> Thanks for using&nbsp;<span class="fp-trademark">{{freshpassText}}<sup>®</sup></span>! Your Points
                                don’t expire. </span>
                                <span *ngIf="freshPassUser" class="sr-only" aria-hidden="false"  id="sr-text-4" aria-live="polite" role="text"> Thanks for using&nbsp; {{freshpassText}}! Your Points
                                don’t expire. </span>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <div *ngIf="showScoreCard" class="mt-4">
            <points-cash-reward (toggleButtonStatus)="changeToggleStatus($event)"
                                [userInfo]="userInfo"
                                [currentEnv]="currentEnvironment" [appHostURL]="appHostURL"
                                [freshPassUser]="freshPassUser" [suspendedFreshPassUser]="suspendedFreshPassUser"
                                [rewardsResponseObj]="rewardsResponseObj"
                                [enableCashReward]="cashRewardsFlow" [pointScoreCardFlow]="pointScoreCardFlow"
                                [cssSizeChange]=true></points-cash-reward>
        </div>
        <ul class="helpingButtonsNav" role="presentation" style="padding-left: 0px;">
            <div *ngIf="showHelpingButtons" class="mt-3">
                <div class="row pb-2 helping-link-buttons">

                    <!-- get your reward - Pick your selected items up online or in-store. -->
                    <div *ngIf="showScoreCard" class="py-2 col-12 col-md-6" id="redeemedRewards">
                        <li>
                            <div (click)="openGetYourRewards()" (keypress)="openGetYourRewards()"
                                 class="text-decoration-none"
                                 role="button" tabindex="0">
                                <div class="new-banner-button"
                                     aria-label="Get your reward pick your selected items up online or in-store button">
                                    <div class="banner-button-container">
                                        <img aria-hidden="true" class="rewards-icon pr-3 pt-1 pb-1" role="img"
                                             alt="Redeem rewards"
                                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/GroceryBag.svg"/>
                                        <div class="banner-text-container">
                                            <div class="banner-main-text" aria-label="Get your reward">Get your reward
                                            </div>
                                            <div class="banner-sub-text"
                                                 aria-label="Pick your selected items up online or in-store.">Pick your
                                                selected items up online or in-store.
                                            </div>
                                        </div>
                                        <img aria-hidden="true" class="arrow" role="img"
                                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/CaretRight.svg"/>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </div>

                    <!-- how it works - Earn 1 Point for every $1 you spend with us. -->
                    <div class="py-2 col-12 col-md-6" id="newHowForUWorksBanner">
                        <li>
                            <div role="button" tabindex="0"
                                 class="text-decoration-none"
                                 (keypress)="openProgramDetails()"
                                 (click)="openProgramDetails()"
                            >
                                <div class="new-banner-button"
                                     aria-label="how it works. Earn 1 Point for every $1 you spend with us.">
                                    <div class="banner-button-container">
                                        <img aria-hidden="true" class="rewards-icon pr-3 pt-1 pb-1" role="img"
                                             alt="howItWorks"
                                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/How-it-Works.svg"/>
                                        <div class="banner-text-container">
                                            <div class="banner-main-text"> How it works</div>
                                            <div class="banner-sub-text"> Earn 1 Point for every $1 you spend with us.
                                            </div>
                                        </div>
                                        <img aria-hidden="true" class="arrow" role="img" alt="rward icon"
                                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/CaretRight.svg"/>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </div>
                </div>

                <div class="row pb-4 helping-link-buttons">
                    <!-- point history - See how you've earned and used Points. -->
                    <div class="py-2 col-12 col-md-6" id="rewardHistory">
                        <li>
                            <div (click)="openRewardsHistory()" (keypress)="openRewardsHistory()"
                                 class="text-decoration-none"
                                 role="button" tabindex="0">
                                <div class="new-banner-button"
                                     aria-label="Points history. Check your earned and used Points.">
                                    <div class="banner-button-container">
                                        <img aria-hidden="true" class="rewards-icon pr-3 pt-1 pb-1" role="img"
                                             alt="rewardsHistory"
                                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/Pts-History.svg"/>
                                        <div class="banner-text-container">
                                            <div class="banner-main-text"> Points history</div>
                                            <div class="banner-sub-text"> Check your earned and used Points.</div>
                                        </div>
                                        <img alt="points history icon" aria-hidden="true" class="arrow" role="img"
                                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/CaretRight.svg"/>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </div>
                    <!-- save at the pump - Use Points to save money on gas. -->
                    <div class="py-2 col-12 col-md-6" id="gasReward" *ngIf="checkFuelAllowedBanner()">
                        <li>
                            <div (click)="setFuelSiteLink()" (keypress)="setFuelSiteLink()" class="text-decoration-none"
                                 role="button" tabindex="0">
                                <div class="new-banner-button"
                                     aria-label="Save at the Pump. Use Points to save money on gas.">
                                    <div class="banner-button-container">
                                        <img aria-hidden="true" class="rewards-icon pr-3 pt-1 pb-1" role="img"
                                             alt="gasReward"
                                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/GasReward.svg"/>
                                        <div class="banner-text-container">
                                            <div class="banner-main-text"> Save at the pump</div>
                                            <div class="banner-sub-text"> Use Points to save money on gas.</div>
                                        </div>
                                        <img alt="gas reward" aria-hidden="true" class="arrow" role="img"
                                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/CaretRight.svg"/>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </div>
                </div>
            </div>
        </ul>
        <ng-container *ngIf="!isPointsForServicesActive && showScoreCard">
            <point-reward-grid *ngIf="showScoreCard" [appHostURL]="appHostURL" [userInfo]="userInfo"
                               [currentEnvironment]="currentEnvironment" [rewardsResponseObj]="rewardsResponseObj"
                               [enableCashReward]="cashRewardsFlow"
                               [pointScoreCardFlow]="pointScoreCardFlow"></point-reward-grid>
        </ng-container>
        <ng-container *ngIf="isPointsForServicesActive">
            <div class="coach-mark-container mask" tabindex="2" aria-live="assertive" role="alert" >
                <div class="coach-mark-content background-color-primary-300">
                    <span id="popup-text" class="coach-mark-text" attr.aria-label="{{popupText}}">{{popupText}}</span>


                    <button
                            class="coach-mark-button background-color-primary-300"
                            aria-label="Dismiss this message"
                            (click)="closeCoachMark()"
                            (keypress)="closeCoachMark()">
                        Got it
                    </button>
                </div>


                <div class="coach-mark-bottom">
                    <svg class="color-primary-300" width="29" height="6" viewBox="0 0 29 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                                d="M7.5 0.000358192L0.503977 2.64993e-06C12.9997 0.00127393 11.5004 6 15.5 6C19.5 6 18 9.17939e-07 28.5 0L20.5 6.99382e-07L7.5 0.000358192Z"
                                fill="currentColor"/>
                    </svg>
                </div>
            </div>
            <div *ngIf="showProgressBar" class="tabs__group mb-4">
                <div class="tabs__list row" role="tablist" #tabsList>
                    <div class="tabs__item col-4">
                        <button
                                id="grocery-rewards"
                                type="button"
                                class="tabs__link"
                                (click)="openPointsTab('rewards');analyticsPageLoad('groceryrewards')"
                                (keydown)="handleKeydown($event, 'rewards');analyticsPageLoad('groceryrewards')"
                                [attr.aria-selected]="isRewardsTabActive"
                                [attr.aria-controls]="'tabpanel-grocery-rewards'"
                                [class.tabs__link--active]="isRewardsTabActive"
                                role="tab"
                                [tabindex]="isRewardsTabActive ? 0 : -1">
                            Grocery Rewards
                        </button>
                    </div>
                    <div class="tabs__item col-4">
                        <button
                                id="more-ways-to-use"
                                type="button"
                                class="tabs__link"
                                (click)="openPointsTab('moreWaysToUse');analyticsPageLoad('morewaystouse')"
                                (keydown)="handleKeydown($event, 'moreWaysToUse');analyticsPageLoad('morewaystouse')"
                                [attr.aria-selected]="ismoreWaysToUseActive"
                                [attr.aria-controls]="'tabpanel-more-ways-to-use'"
                                [class.tabs__link--active]="ismoreWaysToUseActive"
                                role="tab"
                                [tabindex]="ismoreWaysToUseActive ? 0 : -1">
                            More ways to use
                        </button>
                    </div>
                    <div class="tabs__item col-4">
                        <button
                                id="boost-your-points"
                                type="button"
                                class="tabs__link"
                                (click)="openPointsTab('boostYourPoints');analyticsPageLoad('boostyourpoints')"
                                (keydown)="handleKeydown($event, 'boostYourPoints');analyticsPageLoad('boostyourpoints')"
                                [attr.aria-selected]="isBoostYourPointsActive"
                                [attr.aria-controls]="'tabpanel-boost-your-points'"
                                [class.tabs__link--active]="isBoostYourPointsActive"
                                role="tab"
                                [tabindex]="isBoostYourPointsActive ? 0 : -1">
                            Boost your Points
                        </button>
                    </div>
                </div>
            </div>
            <div class="tab-content">
                <div id="rewards" class="tabcontent" role="tabpanel">
                    <ng-container *ngIf="isRewardsTabActive">
                        <point-reward-grid *ngIf="showScoreCard" [appHostURL]="appHostURL" [userInfo]="userInfo"
                                           [currentEnvironment]="currentEnvironment"
                                           [rewardsResponseObj]="rewardsResponseObj"
                                           [enableCashReward]="cashRewardsFlow"
                                           [pointScoreCardFlow]="pointScoreCardFlow"></point-reward-grid>
                    </ng-container>
                </div>
                <div id="moreWaysToUse" class="tabcontent">
                    <ng-container *ngIf="ismoreWaysToUseActive">
                        <ng-container>
                            <app-more-ways-to-use [appHostURL]="appHostURL" [userInfo]="userInfo"
                                                  [currentEnvironment]="currentEnvironment"
                                                  [rewardsResponseObj]="rewardsResponseObj"
                                                  [enableCashReward]="cashRewardsFlow"
                                                  [pointScoreCardFlow]="pointScoreCardFlow"></app-more-ways-to-use>
                        </ng-container>
                    </ng-container>
                </div>
                <div id="boostYourPoints" class="tabcontent">
                    <ng-container *ngIf="isBoostYourPointsActive">
                        <h2 *ngIf="showBoostPointsHeading">Boost your Points</h2>
                        <app-boost-your-points [appHostURL]="appHostURL" [userInfo]="userInfo"
                                               [currentEnvironment]="currentEnvironment"
                                               [rewardsResponseObj]="rewardsResponseObj"
                                               [enableCashReward]="cashRewardsFlow"
                                               [pointScoreCardFlow]="pointScoreCardFlow"></app-boost-your-points>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <ng-container>
            <div class="point-reward-grid-container">
                <point-reward-grid-promotion>
                </point-reward-grid-promotion>
            </div>
        </ng-container>
    </div>
</div>

